import { FC, ReactNode } from 'react'

import s from './styles.module.scss'

interface Props {
  image?: ReactNode
  title?: string
  subTitle?: string
  button?: ReactNode
}

export const EmptyResults: FC<Props> = ({ image, title, subTitle, button }) => {
  const formatedSubtitle = (
    <p
      className={s.subTitle}
      dangerouslySetInnerHTML={{ __html: subTitle || '' }}
    />
  )

  return (
    <div className={s.container}>
      {image}

      <p className={s.title}>{title}</p>

      {formatedSubtitle}

      {button}
    </div>
  )
}
